<template>
  <div class>
    <v-card elevation="0" outlined class="h-100 d-flex flex-column overflow-x-auto" v-if="reports && !loading" min-height="350">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">assignment</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.reportsRequested")}}</span>
          <span
            class="subheader-font body-2"
          >{{$t("dashboards.lastRequested")}}</span>
        </div>
      </v-card-title>
      <div class="d-flex flex-grow-1 flex-column flex-md-row">
        <div class="d-flex flex-grow-1 " v-for="(report,index) in reports" :key="index">
          <InboxReportItem v-bind:class="{'ml-1': index != 0 && $vuetify.breakpoint.mdAndUp}" :report="report" :embedded="true" :states="states"></InboxReportItem>
          <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
        </div>
      </div>
      <div class="d-flex flex-column pl-3 pr-3 pb-1 py-4 mb-7 text-center flex-grow-1" v-if="!reports || !reports.length">
        <v-icon color="primary lighten-5" style="font-size:80px">help_outline</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderReports")}}</span>
      </div>
      <v-divider class="my-1" style=""></v-divider>
      <div class="d-flex justify-end px-2 py-2">
        <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/inbox`">{{$t('dashboards.goInbox')}}</v-btn>
      </div>
    </v-card>
    <v-card class="d-flex justify-center align-center py-8 px-12" v-if="loading">
      <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
import ReportService from "../../../services/report.service";
import InboxReportItem from "../../inbox/InboxReportItem";
import * as moment from "moment";
import * as _ from "lodash";
import ResizeObserver from 'resize-observer-polyfill';

export default {
  name: "ReportsWidget",
  props: {},
  components: {
    InboxReportItem
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  data() {
    return {
      reports: null,
      loading: false,
      observer: null,
      states: []
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
    this.observer = new ResizeObserver(this.onResize).observe(this.$el);
  },
  destroyed() {
    delete this.observer;
  },
  methods: {
    onResize() {
      this.$emit("heightChange", this.$el.clientHeight);
    },
    loadViewData() {
      this.loadReports();
      this.getStates();
    },
    async loadReports() {
      this.loading = true;
      let reportsResponse = await ReportService.getAllDeepReportVisible();
      this.reports = _.chain(reportsResponse.data)
        .filter(r =>  this.currentUser.clientType === 'Driblab' || r.userId === this.currentUser.id)
        .forEach(
          r =>
            (r.createdTime = moment(r.createdAt, "DD/MM/YYYY HH:mm").valueOf())
        )
        .orderBy("createdTime", "desc")
        .slice(0,3)
        .value();
      this.loading = false;
    },
    getStates: async function() {
      let statesResponse = await ReportService.getAllTypeStates();
      this.states = statesResponse.data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/ReportsWidget.vue